import { useSnackBarStore } from "@/shared/stores/snackbar";
import i18n from "@/app/plugins/i18n";
import { getErrorMessage } from "@/shared/utils/errorMessage";

export const copyToClipboard = (item: string) => {
  navigator.clipboard.writeText(item).then(
    () =>
      useSnackBarStore().toastSuccess({
        message: i18n.global.t("common.action.copiedToClipboard"),
      }),
    (err) =>
      useSnackBarStore().toastError({
        message: getErrorMessage(err),
      }),
  );
};
